import { storage } from '../utils'

const setShippingOptions = async (props: any) => {
    const { consignments } = props;
    const quoteShippingMethods = storage.quoteShippingMethods.getValue() ? JSON.parse(storage.quoteShippingMethods.getValue()) : ''
    if ((consignments  as any).length && quoteShippingMethods?.id) {
        const { availableShippingOptions, id } = (consignments as any)[0];
        const { selectShippingOption, setFieldValue } = props;
        if (availableShippingOptions.length > 1) {
            await selectShippingOption(id, quoteShippingMethods.id);
            setFieldValue(`shippingOptionIds.${id}`, quoteShippingMethods.id);
        }
    }
}

const convertShippingAddress = (address: any) => {
    return {
        address1: address.address1,
        address2: address.address2,
        city: address.city,
        company: address.company,
        country: address.country,
        countryCode: address.countryCode,
        customFields: address.customFields,
        email: '',
        firstName: address.firstName,
        lastName: address.lastName,
        phone: address.phone,
        postalCode: address.postalCode,
        shouldSaveAddress: address.shouldSaveAddress,
        stateOrProvince: address.stateOrProvince || '',
        stateOrProvinceCode: address.stateOrProvinceCode,
    }
}

export default {
  setShippingOptions,
  convertShippingAddress
}
